var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "memo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.25 15H7.25C6.83562 15 6.5 15.2812 6.5 15.625C6.5 15.9688 6.83562 16.25 7.25 16.25H13.25C13.6643 16.25 14 15.9702 14 15.625C14 15.2798 13.6625 15 13.25 15ZM17.75 11.25H7.25C6.83562 11.25 6.5 11.5312 6.5 11.875C6.5 12.2188 6.83562 12.5 7.25 12.5H17.75C18.1625 12.5 18.5 12.2188 18.5 11.875C18.5 11.5312 18.1625 11.25 17.75 11.25ZM17.75 7.5H7.25C6.83562 7.5 6.5 7.78125 6.5 8.125C6.5 8.46875 6.83562 8.75 7.25 8.75H17.75C18.1625 8.75 18.5 8.46875 18.5 8.125C18.5 7.78125 18.1625 7.5 17.75 7.5ZM18.5 2.5H6.5C4.84297 2.5 3.5 3.61914 3.5 5V20C3.5 21.3809 4.84297 22.5 6.5 22.5H18.5C20.157 22.5 21.5 21.3809 21.5 20V5C21.5 3.61914 20.1547 2.5 18.5 2.5ZM20 20C20 20.6891 19.3269 21.25 18.5 21.25H6.5C5.67313 21.25 5 20.6891 5 20V5C5 4.31094 5.67313 3.75 6.5 3.75H18.5C19.3269 3.75 20 4.31094 20 5V20Z",
    fill: "#383A3C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.7128582203e9f6be0267c7b85431ff91.svg";
export { ForwardRef as ReactComponent };